// McpPage.tsx — `/mcp`: how to connect an LLM to openscan's MCP server
// (streamable HTTP at /mcp, Bearer auth) and the measurement tools it offers
// (ARCHITECTURE.md §8). All lengths there are millimetres in world mm.
import Table from 'react-bootstrap/Table';
import { urls } from '../api';
import { CopyBlock } from '../components/CopyBlock';

const TOOLS: [string, string][] = [
  ['list_scans {query?}', 'Your scans with status and dimensions'],
  ['get_scan {scan_id}', 'Full scan record plus marker sizes and camera calibration'],
  ['get_dimensions {scan_id}', 'Length / width / height / volume with the bounding boxes'],
  ['measure_distance {scan_id, a, b, snap?}', 'Distance between two world points (mm), optionally snapped to the surface'],
  ['cross_section {scan_id, axis, at_mm, thickness_mm?}', 'Slice outline, width, depth, area and perimeter'],
  ['sample_points {scan_id, n?, label?}', 'Up to 2000 coloured surface points for shape reasoning'],
  ['render_view {scan_id, azimuth_deg, elevation_deg, …}', 'A rendered PNG of the model from any angle'],
  ['segment {scan_id, mode, box_mm?}', 'Re-separate object from background, returning new dimensions'],
];

export default function McpPage() {
  const endpoint = urls.mcp();
  const claudeCmd = `claude mcp add --transport http openscan ${endpoint} --header "Authorization: Bearer $OPENSCAN_TOKEN"`;
  return (
    <>
      <h1 className="h3 mb-3">Measure with an LLM</h1>
      <p className="prose-column">
        openscan speaks the Model Context Protocol, so an assistant can list your scans, read dimensions, take distances
        and slices, and look at rendered views. Authenticate with an authz access token as a Bearer header; the assistant
        only ever sees your own scans. All lengths and coordinates are millimetres in the scan&apos;s world frame
        (origin at the reference marker, Z up).
      </p>
      <div className="card-grid mb-4">
        <CopyBlock title="Endpoint" text={endpoint} caption="MCP streamable HTTP transport." />
        <CopyBlock title="Claude Code" text={claudeCmd} caption="Set OPENSCAN_TOKEN to an authz access token first." />
      </div>
      <h2 className="h5">Tools</h2>
      <Table size="sm" hover responsive>
        <thead>
          <tr>
            <th>Tool</th>
            <th>Returns</th>
          </tr>
        </thead>
        <tbody>
          {TOOLS.map(([name, desc]) => (
            <tr key={name}>
              <td><code>{name}</code></td>
              <td>{desc}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}
